import React from 'react';
import PropTypes from 'prop-types';

export const ImageWebp = ({ srcWebp, src, alt, children, ...props }) => (
  <picture>
    <source srcSet={srcWebp} type="image/webp" />
    <source srcSet={src} type="image/jpeg" />
    <img className={[{ ...props }.className].join(' ')} src={src} alt={alt} />
  </picture>
);

ImageWebp.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.array]),
  srcWebp: PropTypes.string,
  src: PropTypes.string,
  alt: PropTypes.string,
};
ImageWebp.defaultProps = {
  srcWebp: '',
  src: '',
  alt: '',
};
export default ImageWebp;
